import styled from 'styled-components'
import { mobileBreakpoint } from 'react-components'

export const SearchbarContainer = styled.div`
    display: ${props => props.theme.style.display.flex};
    background-color: ${props => props.theme.colors.white};
    flex: 1;
    max-height: 4rem;
    height: 4rem;
    width: 85%;
    max-width: 81.7rem;
    border-radius: 1rem;
    box-shadow: 0 0.375rem 1rem ${props => props.theme.colors.tfwBlackOpacity10};
    justify-content: center;
    align-items: center;
    border: 0.125rem solid ${props => props.theme.colors.tfwYellow};

    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        padding: 0.5rem 0 0 0;
        max-height: fit-content;
        margin-bottom: 0.7rem;
        width: 100%;
        border: 1px solid #d3d3d3;
        scroll-margin-top: 70px;
    }
`

export const SearchbarContent = styled.div<{ maxWidth?: string }>`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: ${props => props.maxWidth || '100%'};
    align-items: center;
    padding: 0 0.375rem;

    @media only screen and (min-width: ${mobileBreakpoint.max}px) {
        flex-direction: row;
        gap: 0.5rem;
        padding: 0;
    }
`

export const SearchButton = styled.button<{ padding?: string; showMainSearchBar?: boolean }>`
    display: none;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: ${props => props.padding || `${props.theme.spacing.small} ${props.theme.spacing.large}`};
    background-color: ${props => props.theme.colors.tfwYellow};
    border: none;
    border-radius: 0.75rem;
    cursor: pointer;
    font-weight: ${props => props.theme.typography.font.weight.semiBold};
    font-size: ${props => props.theme.typography.font.size.medium};
    color: ${props => props.theme.colors.tfwBlack87};
    white-space: nowrap;
    margin: ${props => (props.showMainSearchBar ? '0.5rem' : '0')};

    @media only screen and (min-width: ${mobileBreakpoint.max}px) {
        display: flex;
    }

    span {
        display: none;
    }

    @media only screen and (min-width: 1024px) {
        span {
            display: inline;
        }
    }

    &:hover {
        background-color: ${props => props.theme.colors.tfwYellowDark};
    }

    svg {
        width: 1.5rem;
        height: 1.5rem;
    }
`

export const SubmitButton = styled.button`
    display: flex;
    align-self: stretch;
    padding: ${props => props.theme.spacing.medium};
    background-color: ${props => props.theme.colors.tfwYellow};
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;
    font-weight: ${props => props.theme.typography.font.weight.semiBold};
    font-size: ${props => props.theme.typography.font.size.medium};
    color: ${props => props.theme.colors.tfwBlack87};
    justify-content: center;
    align-items: center;
    margin: 0.75rem 0.5625rem;

    @media only screen and (min-width: ${mobileBreakpoint.max}px) {
        display: none;
    }

    &:hover {
        background-color: ${props => props.theme.colors.tfwYellowDark};
    }
`

export const StickyContainer = styled.div`
    display: flex;
    flex-direction: row;
    background-color: ${props => props.theme.colors.white};
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    padding: ${props => props.theme.spacing.medium} ${props => props.theme.spacing.medium};
    box-shadow: 0 0.5rem 1rem ${props => props.theme.colors.tfwBlackOpacity10};
`

export const StickySearchbarContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 2rem;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 1200px;
`
